import React, { Component } from 'react';
import { connect } from 'react-redux'

import { countryCode, language, locale } from '../../services/translator';
import { getBrand } from '../../services/locale';
import {
  togglePopinAppointment,
  submitPopinAppointment
} from '../../actions/popin';

import Appointment from 'ui-kit/src/components/Appointment/Appointment';
import Popin from 'ui-kit/src/components/Popin/Popin';

class StatefulPopinAppointment extends Component {
  render() {
    return (<Popin
      closeCallback={this.props.closeCallback}
      isOpen={this.props.isPopinAppointmentOpen}
      height={this.props.confirmation ? 'auto' : null}
    >
      {this.props.shop && !this.props.confirmation && (
        <Appointment
          brand={getBrand(language, this.props.shop.cdc)}
          shop={this.props.shop}
          motives={this.props.motives}
          submitCallback={this.props.submitCallback}
          countryCode={countryCode}
          locale={locale}
          lang={language}
        />
      )}
      {this.props.confirmation}
    </Popin>)
  }
}

const mapStateToProps = (state) => {
  return {
    confirmation: state.popin.confirmation,
    isPopinAppointmentOpen: state.popin.isPopinAppointmentOpen,
    motives: state.popin.motives,
    shop: state.pointOfSale.selectedItem
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeCallback: togglePopinAppointment.bind(null, dispatch, false),
    submitCallback: submitPopinAppointment.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(StatefulPopinAppointment);


// WEBPACK FOOTER //
// ./src/components/StatefulPopinAppointment/StatefulPopinAppointment.jsx